var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDotVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.2676C10.5178 11.2676 10.9375 10.8478 10.9375 10.3301C10.9375 9.81231 10.5178 9.39258 10 9.39258C9.48223 9.39258 9.0625 9.81231 9.0625 10.3301C9.0625 10.8478 9.48223 11.2676 10 11.2676Z",
    fill: "#8A8A8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.26758C10.5178 6.26758 10.9375 5.84785 10.9375 5.33008C10.9375 4.81231 10.5178 4.39258 10 4.39258C9.48223 4.39258 9.0625 4.81231 9.0625 5.33008C9.0625 5.84785 9.48223 6.26758 10 6.26758Z",
    fill: "#8A8A8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.2676C10.5178 16.2676 10.9375 15.8478 10.9375 15.3301C10.9375 14.8123 10.5178 14.3926 10 14.3926C9.48223 14.3926 9.0625 14.8123 9.0625 15.3301C9.0625 15.8478 9.48223 16.2676 10 16.2676Z",
    fill: "#8A8A8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotVertical);
export default __webpack_public_path__ + "static/media/ThreeDotVertical.e7e37906b82dcecc126f2fda2234686a.svg";
export { ForwardRef as ReactComponent };